<svelte:options runes={false} />

<script>
  // `APP_STYLE` §6.5: text plus a 6px dot, no background fill, no border. Fills
  // read as badges and badges read as decoration.
  //
  // §9 also forbids conveying status by colour alone, which is why the label is
  // always present and the dot is decorative — the dot adds a second channel, it
  // never carries the meaning by itself.
  export let label;
  export let tone = 'quiet';
</script>

{#if label}
  <span class="status-pill" data-tone={tone}>
    <span class="status-dot" aria-hidden="true"></span>{label}
  </span>
{/if}
